import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ApplicationConfig, ErrorHandler, isDevMode } from '@angular/core';
import { provideRouter, RouteReuseStrategy } from '@angular/router';
import { provideServiceWorker } from '@angular/service-worker';
import { IonicRouteStrategy, ModalController, provideIonicAngular } from '@ionic/angular/standalone';
import { addIcons } from 'ionicons';
import {
  alertCircle,
  alertOutline,
  arrowBack,
  camera,
  checkmarkOutline,
  chevronUpOutline,
  close,
  closeOutline,
  informationCircle,
  logOutOutline,
  send,
  trash,
  trashOutline,
} from 'ionicons/icons';
import { provideMatomo, withRouter as withMatomoRouter } from 'ngx-matomo-client';
import { GlobalErrorHandler } from './app.global-error-handler';
import { routes } from './app.routes';
import { CourseListComponent } from './components/course-components/course-list/course-list.component';
import { ChatWindowComponent } from './components/layout/chat-window/chat-window.component';
import { HomeNavigationBarComponent } from './components/layout/home-navigation-bar/home-navigation-bar.component';
import { MenuContentComponent } from './components/layout/menu/menu-content/menu-content.component';
import { TabsComponent } from './components/layout/tabs/tabs.component';
import { CareerSearchComponent } from './components/search-components/career-search/career-search.component';
import { BrowserInteractionHelper } from './helpers/browser-interaction-helper';
import { CourseHelper } from './helpers/course-helper';
import { DateHelper } from './helpers/date-helper';
import { DeviceHelper } from './helpers/device-helper';
import { ErrorMessageHelper } from './helpers/error-message-helper';
import { FormHelper } from './helpers/form-helper';
import { JsonHelper } from './helpers/json-helper';
import { MatomoHelper } from './helpers/matomo-helper';
import { ObjectConversionHelper } from './helpers/object-conversion.helper';
import { SelectionHelper } from './helpers/selection-helper';
import { StorageHelper } from './helpers/storage-helper';
import { UserHelper } from './helpers/user-helper';

addIcons({
  'alert-circle': alertCircle,
  'alert-outline': alertOutline,
  'arrow-back': arrowBack,
  camera: camera,
  'checkmark-outline': checkmarkOutline,
  'chevron-up-outline': chevronUpOutline,
  close: close,
  'close-outline': closeOutline,
  'information-circle': informationCircle,
  'log-out-outline': logOutOutline,
  send: send,
  trash: trash,
  'trash-outline': trashOutline,
});

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideIonicAngular(),
    provideHttpClient(withInterceptorsFromDi()),
    provideMatomo({ trackerUrl: 'https://matomo.zwh.de/', siteId: '15' }, withMatomoRouter()),
    provideServiceWorker('ngsw-worker.js', {
      enabled: !isDevMode(),
      registrationStrategy: 'registerWhenStable:30000',
    }),
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    { provide: LocationStrategy, useClass: HashLocationStrategy },
    CourseListComponent,
    CareerSearchComponent,
    CourseHelper,
    DateHelper,
    FormHelper,
    StorageHelper,
    SelectionHelper,
    UserHelper,
    ChatWindowComponent,
    TabsComponent,
    ObjectConversionHelper,
    JsonHelper,
    ErrorMessageHelper,
    DeviceHelper,
    BrowserInteractionHelper,
    MatomoHelper,
    MenuContentComponent,
    HomeNavigationBarComponent,
    ModalController,
  ],
};
